import { createPageInfo, type PageInfo } from "./mainSitePages";

export const adminSitePages: PageInfo[] = [
  createPageInfo("Home", "/", "chevron-left", "USER"),
  createPageInfo("Eventi", "/admin/events", "calendar", "ADMIN"),
  createPageInfo("Galleria", "/admin/medias", "image", "MANAGER"),
  createPageInfo("Classifica", "/admin/scores", "ranking-star", "ADMIN"),
  createPageInfo("Tesserati", "/admin/people", "users", "ADMIN"),
  createPageInfo("Percorsi", "/admin/trails", "map", "USER"),
];
